require('./openYoungDashboardExpensesContent.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @constants
const { EURO_TEXT } = require('constants/index');

// @commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKLink } = require('commonsComponents/OKLink');

// @component
const OpenYoungCardExpensesBars = require('routes/openYoungCardsView/openYoungCardBudgetsView/components/openYoungCardExpensesGraph/openYoungCardExpensesBars/openYoungCardExpensesBars');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @utilities
const { getFormattedString, formatCurrency } = require('utilities/currencyHelper');
const { toFirstUppercase } = require('utilities/stringHelper');

class OpenYoungDashboardExpensesContent extends React.Component {
    constructor(props) {
        super(props);

        this.getExpenses = this.getExpenses.bind(this);
        this.getBarContent = this.getBarContent.bind(this);
        this.getMonthContent = this.getMonthContent.bind(this);
    }

    getBarContent(immExpenses) {
        let content;
        if (!immExpenses.get('maxExpense')) {
            content = (
                <EmptyState
                    primaryText={formatText('openYoungCardExpenses-noExpenses')}
                    iconType="search-banking" />
            );
        } else {
            content = (
                <ul className="openyoung-card-expenses-graph__expenses-list">
                    <div className="openyoung-card-expenses-graph__bars-column">
                        <OpenYoungCardExpensesBars
                            maxExpenses={immExpenses.get('maxExpense')}
                            currentPeriod={immExpenses.get('currentPeriod')}
                            comparePeriod={immExpenses.get('previousPeriod')}
                        />
                    </div>
                </ul>
            );
        }
        return content;
    }

    getMonthContent(immExpenses) {
        const currentMonth = immExpenses.get('currentMonth');
        const previousMonth = immExpenses.get('previousMonth');

        const formmatedTotalCurrentPeriod = getFormattedString({
            amount: immExpenses.get('currentPeriod'),
            currency: formatCurrency(EURO_TEXT)
        });
        const formattedTotalPreviousPeriod = getFormattedString({
            amount: immExpenses.get('previousPeriod'),
            currency: formatCurrency(EURO_TEXT)
        });

        return (
            <div className="openyoung-card-expenses-graph__total-period openyoung-card-expenses-graph__total-period--comparison">
                <div className="openyoung-card-expenses-graph__total-current-period">
                    <span className="openyoung-card-expenses-graph__bullet">{currentMonth && toFirstUppercase(currentMonth)}</span>
                    <span className="openyoung-card-expenses-graph__bullet-amount">
                        {formmatedTotalCurrentPeriod}
                    </span>
                </div>
                <div className="openyoung-card-expenses-graph__total-privious-period">
                    <span className="openyoung-card-expenses-graph__bullet openyoung-card-expenses-graph__bullet--previous">{previousMonth && toFirstUppercase(previousMonth)}</span>
                    <span className="openyoung-card-expenses-graph__bullet-amount">
                        {formattedTotalPreviousPeriod}
                    </span>
                </div>
            </div>
        )
    }

    getExpenses() {
        const {
            immOpenYoungDashboardChildDetails,
            cardInfo,
            getChildDetails
        } = this.props;
        let content;

        if (immOpenYoungDashboardChildDetails.get('getChildDetailsFetch')) {
            content = (
                <LoadingSection />
            );
        } else if (immOpenYoungDashboardChildDetails.get('getChildDetailsExpensesError')) {
            const retryButton = (
                <OKButton
                    modifier="link-complementary"
                    onClick={() => getChildDetails(cardInfo)}
                >
                    <FormattedText value="openYoungCardExpenses-retryLink" />
                </OKButton>
            );

            content = (
                <EmptyState
                    primaryText={formatText('openYoungCardExpenses-connectionFailureMessage')}
                    secondaryText={formatText('openYoungCardExpenses-connectionFailureSubMessage')}
                    button={retryButton}
                    iconType="nointernet-banking" />
            );
        }
        else if (immOpenYoungDashboardChildDetails.get('getChildDetailsExpensesSuccess')) {
            const immExpenses = immOpenYoungDashboardChildDetails.get('expenseDetails');
            content = (
                <div className="row openyoung-card-expenses-graph">
                    <div className="col-xs-12">
                        <div className="openyoung-card-expenses-graph__header-content">
                            {this.getMonthContent(immExpenses)}
                            {this.getBarContent(immExpenses)}
                        </div>
                    </div>
                </div>
            );
        }
        else {
            if (immOpenYoungDashboardChildDetails.getIn(['expenseDetails', 'isExpenseResponseNull'])) {
                const noExpensesErrorMessage = formatText('openYoungCardExpenses-noExpensesErrorMessage');
                content = <EmptyState primaryText={noExpensesErrorMessage} iconType="search-banking" />
            }
        }
        return content;
    }
    render() {
        const { cardId } = this.props;
        const gastosTitle = formatText('openYoungDashboardView-openYoungDashboardView_gastosTitle');

        const nextPageButtonContainer = (
            <div className="open-young-dashboard-chore-content__view-more-items">
                <OKLink
                    modifier="widget"
                    inverse={true}
                    to={`/myprofile/cards/${cardId}/budgets`}
                >
                    <FormattedText value="openYoungDashboardView-openYoungDashboardView_viewMoreGastos"/>
                </OKLink>
            </div>
        );
        return (
            <div className="open-young-dashboard-expenses-content">
                <div className="open-young-dashboard-expenses-content__header">
                    <OKBoxTitle
                        value={gastosTitle}
                        isNotSeparator={true}
                    />
                </div>
                <div className="open-young-dashboard-expenses-content__info">
                    {this.getExpenses()}
                </div>
                {nextPageButtonContainer}
            </div>
        )
    }
}

OpenYoungDashboardExpensesContent.propTypes = {
    cardId: PropTypes.string.isRequired,
    cardInfo: PropTypes.object.isRequired,
    getChildDetails: PropTypes.func,
    immOpenYoungDashboardChildDetails: PropTypes.object.isRequired,
};
module.exports = OpenYoungDashboardExpensesContent;